export default "__VITE_ASSET__LER27t0S__"